export default __webpack_public_path__ + "static/media/logo.a3a0d31b.svg";